import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/index/traffic.vue'
wx.createPage(MiniProgramPage)